import { createHash } from "node:crypto";
import type { FeatureEstimate, SensitivityScenario, EstimateReport } from "./schemas.js";

export function generateReport(
  project: string,
  features: FeatureEstimate[],
  sensitivity: SensitivityScenario[],
  rawContent: string,
): EstimateReport {
  const specHash = createHash("sha256").update(rawContent).digest("hex").slice(0, 12);

  const totalTokens = features.reduce((sum, f) => sum + f.withOverhead.total, 0);
  const totalCost = features.reduce((sum, f) => sum + f.estimatedCost, 0);

  return {
    project,
    specHash,
    features,
    totals: {
      tokens: totalTokens,
      cost: Math.round(totalCost * 100) / 100,
    },
    sensitivity,
    generatedAt: new Date().toISOString(),
  };
}
